import { createAsyncThunk } from '@reduxjs/toolkit';

import PAGE_API from './pageSession.api';

export const listPageSessionAction = createAsyncThunk<
any,
PageSession.GetPageSessionDetailPayload
>('pageSession.getList', async ({ data }, { rejectWithValue }) => {
  try {
    const res = await PAGE_API.listPageSessionAPI(data);
    return res;
  } catch (err: any) {
    return rejectWithValue(err);
  }
});

export const detailPageSessionAction = createAsyncThunk<any, { data: string }>(
  'pageSession.getDetail',
  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await PAGE_API.detailPageSessionAPI(data);
      return res;
    } catch (err: any) {
      return rejectWithValue(err);
    }
  }
);

export const createPageSessionAction = createAsyncThunk<
any,
PageSession.PageSessionPostDetailPayload
>('pageSession.create', async ({ data }, { rejectWithValue }) => {
  try {
    const res = await PAGE_API.createPageSessionAPI(data);
    return res;
  } catch (err: any) {
    return rejectWithValue(err);
  }
});

export const updatePageSessionAction = createAsyncThunk<
any,
PageSession.PageSessionPostDetailPayload
>('pageSession.update', async ({ data }, { rejectWithValue }) => {
  try {
    const res = await PAGE_API.updatePageSessionAPI(data);
    return res;
  } catch (err: any) {
    return rejectWithValue(err);
  }
});

export const deletePageSessionAction = createAsyncThunk<
any,
PageSession.DeletePageSessionPayload
>('pageSession.delete', async ({ data }, { rejectWithValue }) => {
  try {
    const res = await PAGE_API.deletePageSessionAPI(data);
    return res;
  } catch (err: any) {
    return rejectWithValue(err);
  }
});

export const listOrderSessionAction = createAsyncThunk<
any,
PageSession.GetListOrdersPayload
>('pageSession.listOrder', async ({ data }, { rejectWithValue }) => {
  try {
    const res = await PAGE_API.listOrderSessionAPI(data);
    return res;
  } catch (err: any) {
    return rejectWithValue(err);
  }
});

export const sortOrderSessionAction = createAsyncThunk<
any,
PageSession.PostSortOrderPayload
>('pageSession.sortOrder', async ({ data }, { rejectWithValue }) => {
  try {
    const res = await PAGE_API.sortOrderSessionAPI(data);
    return res;
  } catch (err: any) {
    return rejectWithValue(err);
  }
});
